import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import { useModals } from '@mantine/modals';
import { Trans } from '@lingui/react';
import { InputField } from '../InputFields';
import { CustomModalHeader, useModalState } from '../../Molecules/Dialogs';
import { TransButtonLink } from '../Buttons';
import TaskEditModal from '../../Molecules/Event/Tasks/TaskEditModal';
import { Icon } from '../Icons';
import { InputHelp } from './InputHelp';

const EditableTaskText = ({
  finishCallback,
  value,
  placeholder,
  disabled,
  patchField,
  style,
  task: initialTask,
  ...rest
}) => {
  const [error, setError] = useState(undefined);
  const [loading, setLoading] = useState(false);

  const [task, setTask] = useState(initialTask);

  const { openContextModal, closeAll } = useModals();

  useEffect(() => {
    setTask(initialTask);
  }, [initialTask]);

  if (!task) {
    return null;
  }

  const toggleCompleted = () => {
    setLoading(true);
    finishCallback({ [patchField]: !value })
      .catch((error) => setError(error.message))
      .then(() => setLoading(false));
  };

  const openTaskEditModal = () =>
    openContextModal('taskEditModal', {
      title: (
        <CustomModalHeader>
          <Trans id="task.edit" />
        </CustomModalHeader>
      ),
      innerProps: {
        initialTask: task,
        entityType: 'events',
        finish: (updatedTask) => {
          setTask(updatedTask);
          closeAll();
        },
      },
      centered: true,
    });

  const styles = {
    error: {
      borderColor: 'red',
    },
    input: {
      marginBottom: 0,
    },
    label: {
      color: '#8ca3b5',
      fontWeight: 800,
    },
    inputContainer: {
      marginBottom: 9,
      ...style,
    },
    name: {
      marginLeft: 20,
      marginTop: -7,
      maxWidth: 150,
    },
    dueDate: {
      fontSize: 11,
      color: '#9499a7',
      marginLeft: 20,
      marginTop: -5,
    },
  };

  return (
    <div style={styles.inputContainer}>
      <div style={{ ...styles.inputContainer, ...style }}>
        <InputField
          isLoading={loading}
          checked={value}
          labelStyle={{}}
          toggle={toggleCompleted}
          text=""
          name={patchField}
          disabled={disabled}
        />
        <TransButtonLink
          style={styles.name}
          className="overflow-ellipsis"
          onClick={openTaskEditModal}
          text={task.name}
        />
        &nbsp;
        {task && task.priority && <Icon style={{ color: '#7d7d7d' }} value="CAUTION" />}
        {task && task.dueDate && (
          <div style={styles.dueDate}>
            Erledigen bis <Moment format="DD.MM.YYYY">{task.dueDate}</Moment>
          </div>
        )}
      </div>
      {error ? <InputHelp errorDescription={error} /> : null}
    </div>
  );
};

EditableTaskText.propTypes = {
  value: PropTypes.bool,
  finishCallback: PropTypes.func,
};

export default EditableTaskText;
